import { alpha, Input as MuiInput, InputProps } from '@mui/material';
import { FC } from 'react';

type Props = InputProps & { small?: boolean; rightAlign?: boolean };

export const Input: FC<Props> = ({ small, rightAlign, ...otherProps }) => {
  return (
    <MuiInput
      {...otherProps}
      disableUnderline
      sx={(theme) => ({
        height: small ? '2.25rem' : '3rem',
        fontSize: small ? '0.875rem' : '1rem',
        background: theme.palette.grey['50'],
        padding: '12px',
        border: '1px solid transparent',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        borderRadius: '8px !important',
        '& .Mui-disabled': {
          opacity: '.5 !important'
        },
        '&.Mui-disabled': {
          background: alpha(theme.palette.grey['50'], 0.5)
        },
        '&.Mui-error': {
          border: `1px solid ${theme.palette.error.main}`
        },
        '&.Mui-focused, &:hover:not(.Mui-disabled)': {
          border: `1px solid ${theme.palette.grey['100']}`
        },
        '& > input': {
          textOverflow: 'ellipsis',
          flexGrow: 1,
          textAlign: rightAlign ? 'right' : 'left'
        }
      })}
    />
  );
};
